module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('md-card', [_c('md-card-content', [_c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "10"
    }
  }, [_c('md-button', {
    staticClass: "md-raised md-primary md-button-color md-theme-default back",
    staticStyle: {},
    on: {
      "click": _vm.previousQuotation
    }
  }, [_vm._v("« Back")])], 1)], 1), _vm._v(" "), _c('hr', {
    staticClass: "hr-s"
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  })], 1), _vm._v(" "), _c('hr', {
    staticClass: "hr-border"
  }), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v(_vm._s(_vm.HubName))])]), _vm._v(" "), (_vm.truckAvability.length > 0) ? _c('div', {
    staticClass: "box-body"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped",
    attrs: {
      "id": "Hub1"
    }
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Vehicle Size")]), _vm._v(" "), _c('th', [_vm._v("Available Truck")]), _vm._v(" "), _c('th', [_vm._v("Booked Truck")]), _vm._v(" "), _c('th', [_vm._v("Total Truck")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.truckAvability), function(item, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_vm._v(_vm._s(item.vehicleType))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "color": "green"
      }
    }, [_vm._v(_vm._s(item.available))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "color": "red"
      }
    }, [_vm._v(_vm._s(item.total - item.available))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.total))])])
  }))])]) : _vm._e()]), _vm._v(" "), (_vm.truckAvability.length <= 0) ? _c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped",
    attrs: {
      "id": "Hub1"
    }
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Vehicle Size")]), _vm._v(" "), _c('th', [_vm._v("Available Truck")]), _vm._v(" "), _c('th', [_vm._v("Booked Truck")]), _vm._v(" "), _c('th', [_vm._v("Total Truck")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.truckAvability), function(item, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_vm._v(_vm._s(item.vehicleType))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "color": "green"
      }
    }, [_vm._v(_vm._s(item.available))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "color": "red"
      }
    }, [_vm._v(_vm._s(item.total - item.available))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.total))])])
  }))])])]) : _vm._e()], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-bcfa5550","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/view/vehicleQuotation/vehicleAvailability.vue
// module id = 2849
// module chunks = 0